export const PI2 = Math.PI * 2;
export const angleAdjustment = Math.PI / 2;
export const maxTextLength = 40;

export const textMargin = 20;

export const minFontSize = 0.5;
export const maxFontSize = 7;

export const margin = 10;

export const canvasSizeCoefficient = 0.85;

export const spinTime = 11000;
export const revolutions = 6;

export const outerRimSize = 20;
